import React from 'react';
import { Logout } from 'src/components/Logout';
import { FlaxLogin } from 'src/components/FlaxLogin';

import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from 'src/components/Spinner';
import { NavLink } from 'react-router-dom';
import { config } from 'src/config';

const UserProfile = (props: React.HTMLAttributes<HTMLElement>) => {
  const { user, isAuthenticated, isLoading, getAccessTokenSilently, getIdTokenClaims } = useAuth0();

  const username = user?.[`${config.AUTH0_CLAIM_NAMESPACE}/username`] ?? user?.nickname ?? user?.name ?? "User";

  if (isLoading) {
    return <Spinner />
  }

  const claimNamespace = config.AUTH0_CLAIM_NAMESPACE;

  return (
    <FlaxLogin>
      {isAuthenticated && <div>
        <a >{username}</a>
        <ul id="profileList" className="uk-background-secondary uk-light uk-list" uk-dropdown="mode: click">
          <li><img src={user?.picture} alt={user?.name} /></li>
          <li>
            <Logout />
          </li>
        </ul>
      </div>
      }
      {!isAuthenticated && <div>Not logged in</div>}
    </FlaxLogin>
  );
};

export default UserProfile;
